import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import {
  fetchFolderById,
  setActiveFolderAsync,
} from "../../redux/actions/folderActions.tsx";
import { CoreLoading } from "../common/CoreLoading.tsx";
import { CardComponent } from "./CardComponent.tsx";
import { Card } from "../material-old";
import { CardExtraInfo } from "./CardExtraInfo.tsx";
import { message } from "antd";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

interface Props {
  folderId: string;
}

export const CardView: React.FC<Props> = ({ folderId }) => {
  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const { activeFolder, loading } = useAppSelector((state) => state.folder);

  useEffect(() => {
    handleInitializeFolders();
  }, [folderId]);

  const handleInitializeFolders = async () => {
    if (loading) return;

    try {
      const folder = await dispatch(fetchFolderById(folderId)).unwrap();
      await dispatch(setActiveFolderAsync(folder));
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudo cargar el expediente."));
    }
  };

  if (!activeFolder) {
    return <CoreLoading size={1} />;
  }

  return (
    <>
      {contextHolder}
      <CardComponent folder={activeFolder} detailed={false} />
      <Card className={`w-full mx-auto p-10`}>
        <CardExtraInfo />
      </Card>
    </>
  );
};
